export const fmtProduct = (product, reviewsQueries) => {
  const rating = reviewsQueries?.data?.reviewStats?.rating;
  const formattedRating = {
    ...product?.rating,
    average: rating?.calculated,
    reviews: rating?.count || null,
  };

  return { ...product, rating: formattedRating };
};
